import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";
import { CompanyUserModel } from "../../types/CompanyUser";
import { removeEmptyKeysFromFilters } from "src/utils/object";

export const RQ_COMPANY_USERS_LIST_KEY = "COMPANY_USERS_LIST_KEY";

export type CompanyUserListResponse = PagedResponse<CompanyUserModel[]>;

export type CompanyUserListFilters = {
    id?: string;
    name?: string;
    email?: string;
};

export const useCompanyUserList = (
    page: number,
    perPage: number,
    searchFilters: CompanyUserListFilters
) => {
    const filters = removeEmptyKeysFromFilters(searchFilters);

    return useQuery({
        queryKey: [
            page,
            perPage,
            RQ_COMPANY_USERS_LIST_KEY,
            filters.id ? `${filters.id}` : "",
            filters.name ? `${filters.name}` : "",
            filters.email ? `${filters.email}` : "",
        ],
        queryFn: async (): Promise<CompanyUserListResponse | null> => {
            const resp = await axiosCompanyInstance.get(`user`, {
                params: { ...filters, page: page + 1, perPage },
            });

            return resp?.data || null;
        },
    });
};
